define(
    'providers/dataprovider.search',[
        "services/config"
    ],
    function (config) {

        function getDisplay() {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-search-display",
                    data: {},
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getSearch(data) {            
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-search-search",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function saveFavoriteField(data) {
            if (data.fieldValue) {
                return $.Deferred(function (deferred) {
                    amplify.request({
                        resourceId: "put-search-save-favorite-field",
                        data: data,
                        success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                        error: function (result, statusCode) { deferred.reject(result, statusCode); }
                    });
                }).promise();
            } else {
                return $.Deferred(function (deferred) {
                    amplify.request({
                        resourceId: "del-search-save-favorite-field",
                        data: data,
                        success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                        error: function (result, statusCode) { deferred.reject(result, statusCode); }
                    });
                }).promise();
            }
        }

        function saveSearchMetadata(data) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "post-search-save-metadata",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getSearchMetadata() {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-search-metadata",
                    data: {},
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function deleteSearchMetadata(data) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "del-search-metadata",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function renameSearchMetadata(data) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-search-metadata",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        //function getFieldList() {
        //    return $.Deferred(function (deferred) {
        //        amplify.request({
        //            resourceId: "get-search-fieldlist",
        //            data: {},
        //            success: function (result, statusCode) { deferred.resolve(result, statusCode); },
        //            error: function (result, statusCode) { deferred.reject(result, statusCode); }
        //        });
        //    }).promise();
        //}
        //function getData(data) {
        //    return $.Deferred(function (deferred) {
        //        amplify.request({
        //            resourceId: "get-search-data",
        //            data: data,
        //            success: function (result, statusCode) { deferred.resolve(result, statusCode); },
        //            error: function (result, statusCode) { deferred.reject(result, statusCode); }
        //        });
        //    }).promise();
        //}

        init();

        return {
            getDisplay: getDisplay,
            getSearch: getSearch,
            saveFavoriteField: saveFavoriteField,
            saveSearchMetadata: saveSearchMetadata,
            getSearchMetadata: getSearchMetadata,
            deleteSearchMetadata: deleteSearchMetadata,
            renameSearchMetadata: renameSearchMetadata
            //getFieldList: getFieldList
            //getData: getData
        };

        //#region Internal Methods

        function init() {

            //#region

            amplify.request.define("get-search-display", "ajax", {
                url: getUrl("search/display"),
                dataType: "json",
                type: "GET"
            });
            
            amplify.request.define("get-search-search", "ajax", {
                url: getUrl("search/metadatahitsuri?libraryId={libraryId}{searchterm}{by}{docstatuses}{documentfieldId}{daterange}{datereview}{nextreviewby}{filetypes}{emailfromto}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("put-search-save-favorite-field", "ajax", {
                url: getUrl("search/searchfieldfavourite/{fieldName}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("del-search-save-favorite-field", "ajax", {
                url: getUrl("search/searchfieldfavourite/{fieldName}"),
                contentType: "application/json",
                dataType: "json",
                type: "DELETE",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("post-search-save-metadata", "ajax", {
                url: getUrl("search/metadatasaveuri/{query}"),
                contentType: "application/json",
                dataType: "json",
                type: "POST",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("get-search-metadata", "ajax", {
                url: getUrl("search/metadatasave"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("del-search-metadata", "ajax", {
                url: getUrl("search/metadatadelete/{id}"),
                contentType: "application/json",
                dataType: "json",
                type: "DELETE",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("put-search-metadata", "ajax", {
                url: getUrl("search/metadataupdate/{id}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            //amplify.request.define("get-search-fieldlist", "ajax", {
            //    url: getUrl("search/fieldlist"),
            //    dataType: "json",
            //    type: "GET"
            //});

            //amplify.request.define("get-search-data", "ajax", {
            //    url: getUrl("search/metadata?libraryId={libraryId}{searchterm}{by}{docstatuses}{documentfieldId}{daterange}{datereview}{nextreviewby}{filetypes}"),
            //    dataType: "json",
            //    type: "GET"
            //});
            //#endregion
        }

        function getUrl(action) {
            return config.webApiUrl + action;
        }

        //#endregion
    }
);
